<template>
  <header class="navbar">
    <router-link to="/" class="logo clearfix">
       <p>一颗红心只为照亮杏林</p>
    </router-link>
    <div class="fill"></div>
    <nav class="nav css1a8429752e20234">
      <li>
        <router-link to="/" exact>
          <h4>首页</h4>
        </router-link>
      </li>
      <li class="line">/</li>
      <li>
        <router-link to="/Person">
          <h4>杏林名家</h4>
        </router-link>
      </li>
       <li class="line">/</li>
        <li>
          <router-link to="/Yewu">
          <h4>主营业务</h4>
        </router-link>
      </li>
       <li class="line">/</li>
        <li>
        <router-link to="/About">
          <h4>关于我们</h4>
        </router-link>
      </li>
       <li class="line">/</li>
        <li>
        <router-link to="/Contact">
          <h4>联系我们</h4>
        </router-link>
        
      </li>
    </nav>
  </header>
</template>

<script>
export default {
  props: {
    //msg: String
  },
  data(){
    return {
      name:this.$route.name
    }
  },
  mounted(){
    console.log(this.$route.name)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar{
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px 20px 40px;
  box-sizing: border-box;
  position: absolute;
  z-index: 100;
}
.logo{
  width: 400px;
  float: left;
}
.logo img{
  border: 0;
  float: left;
}
.logo p{
  float: left;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #fff;
  height: 37px;
  line-height: 37px;
  color: #fff;
  font-size: 17px;
}
.nav{
  text-align: center;
  display: flex;
  float: right;
  height: 50px;
}
.nav .line{
  font-size: 20px;
  color: #fff;
}
.nav li{
  margin: 0 17px;
  float: left;
}
.nav a{
  color: #fff;
}
h4{
  font-size: 18px;
  font-weight: bold;
}
</style>
